import { useEffect, useState } from 'react';
import {
  fetchHeroSlides,
  createHeroSlide,
  updateHeroSlide,
  deleteHeroSlide,
} from '../../api/heroSlider';
import { API_BASE_URL } from '../../utils/constants';

const AdminHeroSlider = () => {
  const [slides, setSlides] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    text: '',
    image: null,
    existingImage: '',
  });

  useEffect(() => {
    loadSlides();
  }, []);

  const loadSlides = async () => {
    try {
      const data = await fetchHeroSlides();
      setSlides(data);
    } catch (err) {
      console.error('Error loading slides:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      if (form.image) formData.append('image', form.image);
      if (form.text) formData.append('text', form.text);
      if (!form.image && form.existingImage) formData.append('existingImage', form.existingImage);

      if (editingId) {
        await updateHeroSlide(editingId, formData);
      } else {
        await createHeroSlide(formData);
      }

      resetForm();
      loadSlides();
    } catch (err) {
      console.error('Error submitting slide:', err);
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setForm({ text: '', image: null, existingImage: '' });
    document.getElementById('hero-image-input').value = '';
  };

  const handleEdit = (slide) => {
    setEditingId(slide.id);
    setForm({
      text: slide.text || '',
      image: null,
      existingImage: slide.image,
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this slide?')) {
      try {
        await deleteHeroSlide(id);
        loadSlides();
      } catch (err) {
        console.error('Error deleting slide:', err);
      }
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="text-xl font-bold"><a href='/admin/dashboard' className='hover:underline'>Admin</a> · Hero Sliders</div>
      <h1 className="text-3xl font-bold mb-4 text-center">{editingId ? 'Edit Slide' : 'Add Slide'}</h1>
      <form onSubmit={handleSubmit} className="space-y-4 mb-10">
        <input
          type="text"
          name="text"
          value={form.text}
          onChange={(e) => setForm((prev) => ({ ...prev, text: e.target.value }))}
          placeholder="Text over the image (optional)"
          className="w-full border p-2 rounded"
        />

        {/* Existing image display */}
        {form.existingImage && !form.image && (
          <div className="relative inline-block">
            <img
              src={`${API_BASE_URL}/uploads/${form.existingImage}`}
              alt="Current Slide"
              className="w-48 h-auto object-cover rounded border"
            />
            <button
              type="button"
              className="absolute top-0 right-0 bg-black text-white rounded-full w-6 h-6 text-xs"
              onClick={() => setForm((prev) => ({ ...prev, existingImage: '' }))}
            >
              ×
            </button>
          </div>
        )}

        <input
          type="file"
          id="hero-image-input"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              setForm((prev) => ({
                ...prev,
                image: file,
                existingImage: '', // if user selects new file, remove old
              }));
            }
          }}
          className="w-full border p-2 rounded"
        />

        {/* Live preview of newly selected image */}
        {form.image && (
          <div className="relative inline-block mt-2">
            <img
              src={URL.createObjectURL(form.image)}
              alt="Preview"
              className="w-48 h-auto object-cover border rounded"
            />
            <button
              type="button"
              className="absolute top-0 right-0 bg-black text-white rounded-full w-6 h-6 text-xs"
              onClick={() => {
                setForm((prev) => ({ ...prev, image: null }));
                document.getElementById('hero-image-input').value = '';
              }}
            >
              ×
            </button>
          </div>
        )}


        <div className="flex gap-4">
          <button type="submit" className="bg-black text-white px-4 py-2 rounded">
            {editingId ? 'Update Slide' : 'Add Slide'}
          </button>
          {editingId && (
            <button
              type="button"
              onClick={resetForm}
              className="text-sm text-gray-500 underline"
            >
              Cancel Edit
            </button>
          )}
        </div>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {slides.map((slide) => (
          <div key={slide.id} className="border p-4 rounded shadow">
            {slide.image && (
              <img
                src={`${API_BASE_URL}/uploads/${slide.image}`}
                alt="Slide"
                className="w-full h-48 object-cover rounded mb-2"
              />
            )}
            <p className="text-sm text-gray-700 mb-2">{slide.text || <i>No text</i>}</p>
            <div className="flex gap-2">
              <button
                onClick={() => handleEdit(slide)}
                className="text-blue-600 hover:underline"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(slide.id)}
                className="text-red-500 hover:underline"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminHeroSlider;
